import {
  CalendarIcon,
  initFlowbite,
  InformationCircleIcon,
  useEffect,
} from "@";

interface NotScheduledCellProps {
  id: string | number;
  label?: string;
  message?: string;
}

const DEFAULT_LABEL = "غير مجدول";
const DEFAULT_MESSAGE =
  "سوف يتم إرسال الطلب للعميل مباشرة بعد الاعتماد من إدارة الجودة";

const NotScheduledCell = ({
  id,
  label = DEFAULT_LABEL,
  message = DEFAULT_MESSAGE,
}: NotScheduledCellProps) => {
  const popoverId = `sms-not-scheduled-${id}`;

  useEffect(() => {
    const t = setTimeout(() => initFlowbite(), 0);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="flex items-center gap-1.5">
      <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-dashed border-gray-200 px-2.5 py-1 text-[11px] font-medium text-gray-400 dark:border-gray-700 dark:text-gray-500">
        <CalendarIcon className="h-3.5 w-3.5" />
        {label}
      </span>
      <button
        type="button"
        data-popover-target={popoverId}
        data-popover-trigger="hover"
        aria-label="معلومات الجدولة"
        className="inline-flex h-5 w-5 items-center justify-center rounded-full text-gray-400 transition-colors hover:text-purple-600 dark:text-gray-500 dark:hover:text-purple-400"
      >
        <InformationCircleIcon className="h-4 w-4" />
      </button>
      <div
        data-popover
        id={popoverId}
        role="tooltip"
        className="invisible absolute z-10 inline-block w-64 rounded-lg border border-gray-200 bg-white text-sm text-gray-600 opacity-0 shadow-sm transition-opacity duration-300 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
      >
        <div className="px-3 py-2 leading-relaxed">{message}</div>
        <div data-popper-arrow></div>
      </div>
    </div>
  );
};

export default NotScheduledCell;
